import "./Highlighter.module.scss";

import React from "react";

// escape for RegExp metachars
function escapeRegExp(value: string) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

interface IHighlighterProps {
    query?: string;
    text: string;
}

class Highlighter extends React.PureComponent<IHighlighterProps> {
    public render() {
        const {query, text} = this.props;

        if (!query) {
            return text;
        }

        const querys = query.split(" ").filter(Boolean);
        const pattern = querys.map((q) => escapeRegExp(q)).join("|");

        return text.split(new RegExp(`(${pattern})`, "i")).map((value, i) => (
            <React.Fragment
                key={i} // this key cannot be unique with "value", therefore we need "i"
            >
                {this.renderHighlighter(querys, value)}
            </React.Fragment>
        ));
    }

    private renderHighlighter(querys: string[], value: string) {
        const match = querys // text just for better styling against prettier
            .some((x) => value.toLowerCase() === x.toLowerCase());
        if (match) {
            return <span styleName="highlighter">{value}</span>;
        }

        return value;
    }
}

export default Highlighter;
